import { makeBaseGraphQLReducer } from '.'
import { dataFetchedReducerFactory, GRAPHQL_DATA_FETCHED } from './dataFetched'
import { dataAddedReducerFactory, GRAPHQL_DATA_ADDED } from './dataAdded'
import { dataRemovedReducerFactory, GRAPHQL_DATA_REMOVED } from './dataRemoved'

export function makeGraphQLReducer(options) {
  return makeBaseGraphQLReducer({
    ...options,
    subReducerFactories: {
      [GRAPHQL_DATA_FETCHED]: dataFetchedReducerFactory,
      [GRAPHQL_DATA_ADDED]: dataAddedReducerFactory,
      [GRAPHQL_DATA_REMOVED]: dataRemovedReducerFactory,
    },
  })
}
